import Pickers from './Pickers.vue'

export default Pickers
